import { render, staticRenderFns } from "./Buffer.vue?vue&type=template&id=2f7e2916"
import script from "./Buffer.vue?vue&type=script&lang=js"
export * from "./Buffer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports